import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const testimonials = [
  {
    quote:
      "B-fos transformed a complex district road program into a highly coordinated delivery process. Their engineering rigor and local insight significantly improved execution quality.",
    author: "Jean Claude N., Infrastructure Director",
  },
  {
    quote:
      "From concept review to final supervision, the B-fos team maintained exceptional control over risk, schedule, and stakeholder communication across our mixed-use development.",
    author: "Aline M., Real Estate Project Lead",
  },
  {
    quote:
      "Their environmental and planning recommendations helped us secure approvals faster while preserving long-term sustainability objectives for our site in Kigali.",
    author: "Patrick R., Public Sector Client",
  },
];

const TestimonialsPremium = () => {
  const sectionRef = useRef(null);
  const trackRef = useRef(null);

  useGSAP(
    () => {
      const track = trackRef.current;
      if (!track) return;

      const tween = gsap.to(track, {
        xPercent: -50,
        duration: 28,
        ease: "none",
        repeat: -1,
      });

      track.addEventListener("mouseenter", () => tween.pause());
      track.addEventListener("mouseleave", () => tween.resume());
    },
    { scope: sectionRef }
  );

return (
    <section id="testimonials" ref={sectionRef} className="relative overflow-hidden py-24 sm:py-28">
      {/* Background Image */}
      <div
        className="absolute inset-0 scale-110 bg-cover bg-center"
        style={{ backgroundImage: "url('/img/testimonials/Testimonial_BG.jpeg')" }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-midnight/90 via-surface/85 to-surfaceSoft/90" />
      
      <div className="section-shell mb-10 relative z-10">
        <div className="section-title">
          <p className="section-kicker">Testimonials</p>
          <h2 className="section-heading">Trusted across Rwanda’s built environment</h2>
        </div>
      </div>

      <div className="overflow-hidden">
        <div ref={trackRef} className="flex w-[200%] gap-6 px-4 sm:px-6 lg:px-8">
          {[...testimonials, ...testimonials].map((item, idx) => (
            <article key={`${item.author}-${idx}`} className="glass-card min-h-[220px] w-[340px] shrink-0 p-6 sm:w-[420px]">
              <p className="text-sm leading-relaxed text-slate-200">“{item.quote}”</p>
              <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-amber-400">
                {item.author}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsPremium;
